import React, { Component } from 'react';
import { connect } from 'react-redux';
import SliderForm from './SliderForm';
import privateView from '../../components/hocs/privateView';
import Analytics from "../../services/Analytics";

class SliderCreate extends Component{
	componentDidMount(){
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('slider_detail', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }
  render(){
    return (
      <div>
        <SliderForm
          title="Create New Slider"
          {...this.props}
        />
      </div>
    )
  }
}

const mapStateToProps = ({auth: { isFetch, roles, isLogged, id, email } })=>({
  guardData: { isFetch, roles, isLogged, id, email }
})

const enhance = connect(mapStateToProps);
export default enhance(privateView(SliderCreate))